define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../models/CPUserImportModel"], function (require, exports, $, ko, log, tools, KendoUtils, CPUserImportModel) {
    "use strict";
    var ImportCPUsers = /** @class */ (function () {
        function ImportCPUsers() {
            this.editModel = ko.observable(new CPUserImportModel());
            this.resulModel = ko.observable();
            this.hasResults = ko.observable(false);
            this.importFinished = ko.observable(false);
            this.lastError = "";
            this.isImportValid = false;
            this.roles = [];
            this.importData = [];
        }
        ImportCPUsers.prototype.init = function () {
        };
        ImportCPUsers.prototype.import = function (customerProfileId, callback) {
            var self = this;
            self.customerProfileId = customerProfileId;
            self.resulModel = ko.observable();
            self.hasResults(false);
            self.importFinished(false);
            tools.editModal({
                title: "Customer Portal Import",
                buttonTitle: "Import",
                modalClass: "full-width",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (self.importData.length <= 0) {
                        tools.error("Data is empty");
                        return;
                    }
                    self.validateAllRecords();
                    if (!self.isImportValid) {
                        tools.error(self.lastError ? self.lastError : "Some of import records are not valid");
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.processImport(event.currentTarget, modal, callback);
                },
                opened: function (modal) {
                    self.importData = [];
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/CPCustomerUsers/ImportLookupData",
                        data: { customerProfileId: self.customerProfileId },
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                                self.roles = data.Data.lookupLists.Roles;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cp-users-import-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.initImportGrid(self.lookupLists.GridStructures.CPUsersImportList);
                    });
                }
            });
        };
        ImportCPUsers.prototype.initImportGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.addEditActionColumn(columns);
            self.importCPUsersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    //data: self.importData,
                    transport: {
                        read: function (options) {
                            options.success(self.importData);
                        },
                        create: function (options) {
                            self.importData.push(options.data);
                            options.success(options.data);
                        },
                        update: function (options) {
                            var dataItem = ko.utils.arrayFirst(self.importData, function (item) {
                                return item.Id === options.data.Id;
                            });
                            if (dataItem) {
                                $.extend(dataItem, options.data);
                            }
                            options.success(options.data);
                        },
                        destroy: function (options) {
                            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Id === options.data.Id; });
                            ko.utils.arrayRemoveItem(self.importData, dataRow);
                            options.success(options.data);
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    },
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#cp-users-import-toolbar").html()),
                    height: 500,
                    columns: columns,
                    dataBound: function (e) {
                        var dataItems = e.sender.dataSource.view();
                        for (var j = 0; j < dataItems.length; j++) {
                            var error = dataItems[j].get("Error");
                            if (error) {
                                console.error(error);
                                var row = e.sender.tbody.find("[data-kendo-uid='" + dataItems[j].uid + "']");
                                row.addClass("alert-danger");
                            }
                        }
                    },
                    editable: {
                        mode: "inline"
                    },
                    save: function (e) {
                        var roles = self.roles.filter(function (role) {
                            return role.Value === e.model.RoleId;
                        });
                        if (roles || roles.length > 0) {
                            e.model.RoleName = roles[0].Text;
                        }
                        else {
                            e.model.RoleName = '';
                        }
                        self.validateOneRecord(e.model);
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    },
                    remove: function (e) {
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    }
                },
                gridId: "importPreviewTable",
                enableExport: {
                    entityName: "CPUser",
                    title: "Customer Portal Users",
                    enablePdf: false
                }
            };
            self.importCPUsersTable.initGrid(gridOptions);
            setTimeout(function () {
                self.importCPUsersTable.refresh();
            });
            $("#importPreviewTable .btn-clear-rows").on("click", function (event) {
                var r = confirm("Are you sure you want to remove all rows");
                if (r) {
                    self.importData = [];
                    self.importCPUsersTable.refresh();
                }
            });
            $("#importPreviewTable .btn-export").on("click", function (event) {
                var gridData = self.importCPUsersTable.getGridData();
                gridData.saveAsExcel();
                event.preventDefault();
            });
            $("#importPreviewTable .k-grid-content").on("click", ".btn-remove", function (event) {
                KendoUtils.KendoUtils.removeGridRow(this);
                event.preventDefault();
            }).on("paste", function (event) {
                var pastedText = undefined;
                if (window["clipboardData"] && window["clipboardData"].getData) { // IE
                    pastedText = window["clipboardData"].getData("Text");
                }
                else if (event.originalEvent["clipboardData"] && event.originalEvent["clipboardData"].getData) {
                    pastedText = event.originalEvent["clipboardData"].getData("text/plain");
                }
                setTimeout(function () {
                    // the the pasted content
                    var value = $.trim(pastedText);
                    // get the pasted rows - split the text by new line
                    var rows = value.split("\n");
                    var maxId = 0;
                    ko.utils.arrayForEach(self.importData, function (item) {
                        maxId = item.Id > maxId ? item.Id : maxId;
                    });
                    maxId++;
                    for (var i = 0; i < rows.length; i++) {
                        // get the cells - split by tab
                        var cells = rows[i].split("\t");
                        var roleName = cells[3] || '';
                        var roles = self.roles.filter(function (role) {
                            return role.Text.toLowerCase() === roleName.toLowerCase();
                        });
                        var userRole = roles[0] || {};
                        self.addNewRecord({
                            Id: maxId++,
                            Email: cells[0],
                            FirstName: cells[1] || '',
                            LastName: cells[2] || '',
                            RoleId: userRole.Value || 0,
                            RoleName: userRole.Text || '',
                            PhoneNumber: cells[4] || '',
                            Extension: cells[5] || '',
                            Approved: cells[6] || false,
                            EnableCouterPath: cells[7] || false,
                            EnableLdap: cells[8] || false,
                            SendInvitation: cells[9] || false,
                        });
                    }
                    self.importCPUsersTable.refresh();
                });
                return false; // Prevent the default handler from running.
            });
        };
        ImportCPUsers.prototype.addEditActionColumn = function (columns) {
            var self = this;
            var actions = {
                field: "",
                command: ["edit", "destroy"],
                width: "86px"
            };
            columns.push(actions);
            //check custom editor
            var customEditors = {};
            customEditors["RoleEditor"] = function (container, options) {
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                    dataTextField: "Text",
                    dataValueField: "Value",
                    filter: "contains",
                    autoBind: true,
                    minLength: 1,
                    dataSource: {
                        data: self.roles
                    }
                }).data("kendoComboBox");
            };
            ko.utils.arrayForEach(columns, function (column) {
                if (column.hasOwnProperty("editor")) {
                    column["editor"] = customEditors[column["editor"]];
                }
            });
            return columns;
        };
        ImportCPUsers.prototype.validateAllRecords = function () {
            var self = this;
            var dataGrid = self.importCPUsersTable.getGridData();
            self.isImportValid = true;
            ko.utils.arrayForEach(self.importData, function (item) {
                if (!self.validateOneRecord(item)) {
                    self.isImportValid = false;
                    self.lastError = item.Error;
                }
            });
            dataGrid.dataSource.read();
        };
        ImportCPUsers.prototype.validateOneRecord = function (record) {
            var self = this;
            record.Error = "";
            if (!record.Email) {
                record.Error = "Email is required";
                return false;
            }
            if (record.PhoneNumber) {
                var regularExpression = /^[a-zA-Z0-9]+$/;
                var valid = regularExpression.test(record.PhoneNumber);
                if (!valid) {
                    record.Error = "Phone number - digits and characters are allowed only";
                    return false;
                }
            }
            if (!record.FirstName) {
                record.Error = "First Name is required field";
                return false;
            }
            if (!record.LastName) {
                record.Error = "Last Name is required field";
                return false;
            }
            if (!record.RoleId) {
                record.Error = "Role is required field";
                return false;
            }
            if (record.EnableCouterPath && !record.Extension) {
                record.Error = "Extension is required field if CounterPath is enabled";
                return false;
            }
            return true;
        };
        ImportCPUsers.prototype.addNewRecord = function (record) {
            var self = this;
            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Email === record.Email; });
            if (dataRow) {
                // update row with new values
                dataRow.FirstName = record.FirstName !== undefined ? record.FirstName : dataRow.FirstName;
                dataRow.LastName = record.LastName !== undefined ? record.LastName : dataRow.LastName;
                dataRow.Email = record.Email !== undefined ? record.Email : dataRow.Email;
                dataRow.PhoneNumber = record.PhoneNumber !== undefined ? record.PhoneNumber : dataRow.PhoneNumber;
                dataRow.Extension = record.Extension !== undefined ? record.Extension : dataRow.Extension;
                dataRow.RoleId = record.RoleId !== undefined ? record.RoleId : dataRow.RoleId;
                dataRow.Approved = record.Approved !== undefined ? record.Approved : dataRow.Approved;
                dataRow.EnableCouterPath = record.EnableCouterPath !== undefined ? record.EnableCouterPath : dataRow.EnableCouterPath;
                dataRow.EnableLdap = record.EnableLdap !== undefined ? record.EnableLdap : dataRow.EnableLdap;
                dataRow.SendInvitation = record.SendInvitation !== undefined ? record.SendInvitation : dataRow.SendInvitation;
                self.validateOneRecord(record);
            }
            else {
                record.FirstName = record.FirstName || "";
                record.LastName = record.LastName || "";
                record.Email = record.Email || "";
                record.PhoneNumber = record.PhoneNumber || "";
                record.Extension = record.Extension || "";
                record.RoleId = record.RoleId || 0;
                record.Approved = record.Approved || false;
                record.EnableCouterPath = record.EnableCouterPath || false;
                record.EnableLdap = record.EnableLdap || false;
                record.SendInvitation = record.SendInvitation || false;
                self.validateOneRecord(record);
                // add a new item in the grid
                self.importData.push(record);
            }
        };
        ImportCPUsers.prototype.processImport = function (btn, modal, callback) {
            var self = this;
            self.hasResults(false);
            var data = {
                customerProfileId: self.customerProfileId,
                jsonData: ko.toJSON(self.importData)
            };
            tools.ajaxPost({
                url: "/CPCustomerUsers/ImportCPUsers",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    self.resulModel(ko.mapping.fromJS(result.Data, {}));
                    if (callback) {
                        callback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
                self.hasResults(result.Success);
                log.log(result);
            }).always(function () {
                $(btn).button("reset");
                self.importFinished(true);
            });
        };
        return ImportCPUsers;
    }());
    return ImportCPUsers;
});
//# sourceMappingURL=importCPUsers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/import/importCPUsers.js
// module id = 173
// module chunks = 2